export enum ForumInvitationStatus {
  Open,
  Accepted,
  Rejected,
  Canceled
}
